import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { produce } from "../../../../../../../../libs/immer";
import { EStatus } from "../../../../../../../../constants";
import { EPaymentMethod } from "../../../../../../../dependencies/getContent/constants";
import { QRCodeStorage } from "../../dependencies/initializeQRCode/QRCode";
export var pollSbpStatusUseCase = function pollSbpStatusUseCase(_ref) {
  var pollSbpStatus = _ref.pollSbpStatus;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      var status;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return pollSbpStatus({
              accountNumber: getState().phoneInput.value,
              payId: "".concat(QRCodeStorage.getInstance().getData().payId) || undefined
            });
          case 3:
            status = _context.sent;
            setState(produce(function (draft) {
              var _draft$scenario;
              if (((_draft$scenario = draft.scenario) === null || _draft$scenario === void 0 ? void 0 : _draft$scenario.type) !== EPaymentMethod.SBP) return;
              draft.statusPopup = status;
            }));
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            setState(produce(function (draft) {
              var _draft$scenario2;
              if (((_draft$scenario2 = draft.scenario) === null || _draft$scenario2 === void 0 ? void 0 : _draft$scenario2.type) !== EPaymentMethod.SBP) return;
              draft.statusPopup = EStatus.Error;
            }));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};